import { createTheme } from "@mui/material";

const muiTheme = createTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#FFFFFF",
    },
    secondary: {
      main: "rgba(255,255,255, 0.2)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "proxima-nova, sans-serif",
          borderRadius: 100,
        },
      },
    },
    MuiSkeleton: {
      defaultProps: {
        sx: { bgcolor: "grey.800" },
      },
    },
  },
  typography: {
    fontFamily: "proxima-nova, sans-serif",
  },
});

export default muiTheme
